import CalendarForRooms from "../calendarForRooms";
import Calendar2 from "../../components/calendar2";

export default function Calendar2Container() {
  return (
    <div className="CONTAINER flex- justify-center ">
      <Calendar2 />
    </div>
  );
}
